import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { getCommunityMembersKey, getCommunityQueryKey } from '..';
import { changeRoleInComunity } from '../../services';

export const useDeleteUserFromComunity = () => {
  const queryClient = useQueryClient();

  return useMutation<undefined, { userId: string; communityId: string }>(
    async ({ userId, communityId }) => {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      const result = await changeRoleInComunity({
        user_id: userId,
        entity_ids: [communityId],
        role: 'none',
      });
      return result.data;
    },
    /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

    {
      onSuccess(_, params: { communityId: string }) {
        queryClient.invalidateQueries(getCommunityQueryKey({ id: params.communityId }));
        queryClient.invalidateQueries(getCommunityMembersKey({ communityId: params.communityId }));
      },
    },
  );
};
